import React from 'react';
import PropTypes from 'prop-types';
import Bone from '@lightspeed/cirrus-bone';
import { Button } from '@lightspeed/flame/Button';
import Card, { CardSection } from '@lightspeed/cirrus-card';
import { IconVerified } from '@lightspeed/flame/Icon/Verified';
import Text, { TextContent } from '@lightspeed/cirrus-text';

const WrappedComponent = ({ gatewayConfig, onConfigureClick }) =>
  gatewayConfig && gatewayConfig.length ? (
    <Card>
      <CardSection noSpacing>
        <div
          style={{
            background: `url('https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-9919532/images/payments/lspayments-banner.svg') no-repeat`,
            minWidth: '570px',
            height: '238px',
            borderRadius: '0.375rem',
          }}
        >
          <div className="cr-flex cr-justify-end cr-items-center" style={{ height: '100%' }}>
            <div
              className="cr-flex cr-justify-between cr-items-center cr-radius-2"
              style={{
                backgroundImage:
                  'linear-gradient(to right, rgba(255,255,255,0), rgba(255,255,255,0.95)10%)',
                paddingLeft: '5%',
                minWidth: '80%',
                height: '100%',
              }}
            >
              <div className="cr-pl-5">
                <div>
                  <img
                    src="https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-9919532/images/payments/lspayments-logo.svg"
                    alt="Lightspeed Payments"
                    style={{ width: '211px' }}
                  />
                </div>
                <div style={{ maxWidth: '272px', paddingLeft: '45px' }}>
                  <Text bodySmall>
                    Lightspeed Payments is the simplest way to start processing credit and debit
                    cards both in-store and online
                  </Text>
                </div>
              </div>
              <div className="cr-p-4" style={{ height: '100%' }}>
                <div
                  className="cr-card cr-flex cr-justify-center cr-items-center"
                  style={{ height: '100%' }}
                >
                  <div className="cr-flex cr-m-4">
                    <div className="cr-mr-2">
                      <IconVerified baseColor="green" />
                    </div>
                    <div>
                      <TextContent>
                        <Text bold>Account Active</Text>
                        <div style={{ maxWidth: '240px' }}>
                          <Text bodySmall dimmed>
                            Your Lightspeed Payments account is active and ready to process payments
                          </Text>
                        </div>
                      </TextContent>

                      <div className="cr-mt-3">
                        <Button variant="secondary" onClick={onConfigureClick}>
                          Configure
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CardSection>
    </Card>
  ) : null;

const LightspeedPayments = ({ isLoading, ...rest }) =>
  isLoading ? (
    <Card>
      <CardSection>
        <div style={{ height: '12rem' }}>
          <Bone width="40%" height="2rem" />
          <div className="cr-mt-4">
            <Bone width="50%" height="1rem" />
          </div>
          <div className="cr-mt-4">
            <Bone width="50%" height="1rem" />
          </div>
        </div>
      </CardSection>
    </Card>
  ) : (
    <WrappedComponent {...rest} />
  );

LightspeedPayments.propTypes = {
  isLoading: PropTypes.bool,
  gatewayConfig: PropTypes.arrayOf(PropTypes.shape()),
  onConfigureClick: PropTypes.func,
};

LightspeedPayments.defaultProps = {
  isLoading: true,
  gatewayConfig: [],
  onConfigureClick: () => {},
};

export default LightspeedPayments;
